import type {
  AgentConfigBody,
  ExpertSummary,
  LiveQuestion,
  MeetingChannels,
  QaItem,
} from "../api";
import { Eyebrow } from "./Eyebrow";
import { ApprovalQueue } from "./ApprovalQueue";

/// Center-stage Q&A surface for the in-meeting page. The queue itself
/// owns the tabbed Approval queue / Chat of record split; this wrapper
/// only renders the off-state when `channels.qa` is disabled or after
/// the meeting wraps.
export function RightRail({
  meetingId,
  experts,
  agent,
  channels,
  qaItems,
  liveQuestions,
  phase,
  onQaItemsChange,
}: {
  meetingId: string;
  experts: ExpertSummary[];
  agent: AgentConfigBody;
  channels: MeetingChannels;
  qaItems: QaItem[];
  liveQuestions: LiveQuestion[];
  phase: "in_meeting" | "meeting_over" | "finalized";
  onQaItemsChange: (next: QaItem[]) => void;
}) {
  if (channels.qa) {
    return (
      <ApprovalQueue
        meetingId={meetingId}
        items={qaItems}
        experts={experts}
        liveQuestions={liveQuestions}
        agent={agent}
        onItemsChange={onQaItemsChange}
      />
    );
  }
  return (
    <section
      style={{
        background: "var(--card)",
        border: "1px solid var(--rule)",
        borderRadius: "var(--r-3)",
        padding: "var(--space-4)",
      }}
    >
      <Eyebrow>Chat of record</Eyebrow>
      <div
        style={{
          marginTop: "var(--space-2)",
          color: "var(--ink-3)",
          font: "var(--type-body-sm)",
        }}
      >
        {phase === "in_meeting"
          ? "Approval queue is disabled for this meeting. Bot messages stream into the meeting chat directly."
          : "Meeting wrapped — chat is read-only."}
      </div>
    </section>
  );
}
